
import { Component, Vue } from "vue-property-decorator";
import UserList from "@/components/User/List.vue";
@Component({
  components: {
    UserList,
  },
})
export default class UserIndex extends Vue {}
